// Utilidades para gestionar la autenticación y persistencia de conexión de wallet

/**
 * Guarda la dirección de la wallet en localStorage para mantener la sesión
 * @param {string} address - Dirección de la wallet conectada
 */
export const saveWalletConnection = (address) => {
  if (address) {
    try {
      localStorage.setItem('walletAddress', address);
      localStorage.setItem('lastConnected', Date.now().toString());
      console.log(`[Auth] Conexión guardada para: ${address}`);
    } catch (error) {
      console.error('[Auth] Error al guardar la conexión en localStorage:', error);
    }
  }
};

/**
 * Limpia los datos de conexión de localStorage al desconectar
 */
export const clearWalletConnection = () => {
  try {
    localStorage.removeItem('walletAddress');
    localStorage.removeItem('lastConnected');
    // Limpiar también datos de WalletConnect para evitar problemas de reconexión
    localStorage.removeItem('wc@2:core:0.3//subscription');
    localStorage.removeItem('wagmi.store');
    localStorage.removeItem('wagmi.wallet');
    localStorage.removeItem('wagmi.connected');
    console.log('[Auth] Conexión eliminada');
  } catch (error) {
    console.error('[Auth] Error al limpiar la conexión en localStorage:', error);
  }
};

/**
 * Obtiene la dirección guardada en localStorage (si existe)
 * @returns {string|null} Dirección de wallet o null si no está conectado
 */
export const getSavedWalletAddress = () => {
  try {
    return localStorage.getItem('walletAddress');
  } catch (error) {
    console.error('[Auth] Error al obtener la dirección desde localStorage:', error);
    return null;
  }
};

/**
 * Detecta si estamos en un dispositivo móvil
 * @returns {boolean} True si es un dispositivo móvil
 */
export const isMobileDevice = () => {
  return (
    typeof window !== 'undefined' && (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
      (navigator.maxTouchPoints && navigator.maxTouchPoints > 2)
    )
  );
};

/**
 * Verifica si el usuario está autenticado (tiene wallet conectada)
 * @param {string|undefined} currentAddress - Dirección actual de useAccount
 * @returns {boolean} True si está autenticado
 */
export const isAuthenticated = (currentAddress) => {
  // Verificar primero la dirección actual de useAccount (conexión activa)
  if (currentAddress) {
    try {
      // Si la dirección existe, asegurarse de que esté guardada en localStorage
      saveWalletConnection(currentAddress);
      return true;
    } catch (error) {
      console.error('[Auth] Error al guardar la dirección actual:', error);
    }
  }
  
  // Verificación especial para dispositivos móviles donde localStorage puede fallar
  const isMobile = isMobileDevice();
  if (isMobile) {
    // En móviles, el currentAddress es más confiable que localStorage
    return !!currentAddress;
  }
  
  // Si no hay conexión activa, verificar si hay una dirección guardada en localStorage
  try {
    const savedAddress = getSavedWalletAddress();
    const isValid = !!savedAddress;
    
    // Verificar si la sesión es reciente (menos de 1 día)
    if (isValid) {
      const lastConnected = parseInt(localStorage.getItem('lastConnected') || '0');
      const now = Date.now();
      // Si han pasado más de 24 horas, considerar la sesión expirada
      if (now - lastConnected > 24 * 60 * 60 * 1000) {
        console.log('[Auth] Sesión expirada, limpiando datos de conexión');
        clearWalletConnection();
        return false;
      }
    }
    
    return isValid;
  } catch (error) {
    console.error('[Auth] Error al verificar autenticación:', error);
    return false;
  }
}; 